import { useNavigate } from "../utils";

export const FloatingBackButton = () => {
  const navigate = useNavigate();

  return (
    <img
      src="/images/back.png"
      alt="back"
      onClick={() => navigate(-1)}
      style={{
        position: "fixed",
        width: 56,
        height: 56,
        top: 4,
        left: 0,
        padding: 16,
      }}
    />
  );
};
